if (!customElements.get('btl-desktop-navigation')) {
  customElements.define('btl-desktop-navigation', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.panel = this.querySelector('[data-category-popover]');
      this.browser = this.querySelector('btl-category-browser');
      this.buttons = [...this.querySelectorAll('[data-browse-department]')];
      if (!this.panel || !this.browser || !this.buttons.length) return;
      this.desktop = window.matchMedia('(min-width: 990px)');
      const options = { signal: this.controller.signal };
      this.close(false);
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-browse-department]');
        if (!this.buttons.includes(button)) return;
        if (this.activeButton === button && !this.panel.hidden) this.close(false);
        else this.open(button);
      }, options);
      this.addEventListener('keydown', event => this.onKeydown(event), options);
      this.addEventListener('pointerover', event => {
        clearTimeout(this.hoverTimer);
        const button = event.target.closest('[data-browse-department]');
        if (event.pointerType !== 'mouse' || this.dataset.openOnHover !== 'true' || !this.buttons.includes(button)) return;
        if (this.contains(document.activeElement) && !this.buttons.includes(document.activeElement)) return;
        this.hoverTimer = setTimeout(() => {
          this.open(button, false, true);
          this.hoverOpened = !this.panel.hidden;
        }, 140);
      }, options);
      this.addEventListener('pointerleave', () => {
        clearTimeout(this.hoverTimer);
        if (this.hoverOpened && !this.contains(document.activeElement)) this.close(false);
      }, options);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close(false);
      }, options);
      const dismissOutside = event => {
        const button = event.target.closest?.('[data-browse-department]');
        if (!this.panel.contains(event.target) && !this.buttons.includes(button)) this.close(false);
      };
      for (const type of ['pointerdown', 'click']) {
        document.addEventListener(type, dismissOutside, { ...options, capture: true });
      }
      document.addEventListener('keydown', event => {
        if (event.key !== 'Escape' || this.panel.hidden) return;
        event.preventDefault(); event.stopPropagation(); this.close(true);
      }, { ...options, capture: true });
      for (const type of ['resize', 'scroll']) { window.addEventListener(type, () => this.updateAvailableHeight(), { ...options, passive: true }); } this.desktop.addEventListener('change', () => {
        if (!this.desktop.matches) this.close(false);
      }, options);
      if (window.Shopify?.designMode) {
        document.addEventListener('shopify:block:select', event => {
          const blockId = event.detail?.blockId;
          const button = this.buttons.find(item => item.dataset.browseCategory &&
            (blockId === item.dataset.browseCategory || blockId?.endsWith('__' + item.dataset.browseCategory)));
          if (button) this.open(button, false, true);
        }, options);
      }
    }
    open(button, focus = false, preserveFocus = false) {
      if (!this.desktop.matches || !this.buttons.includes(button)) return;
      clearTimeout(this.hoverTimer);
      this.hoverOpened = false;
      this.panel.hidden = false;
      this.activeButton = button;
      this.buttons.forEach(item => item.setAttribute('aria-expanded', String(item === button)));
      const groupCount = this.browser.showDepartment(button.dataset.browseDepartment, button.dataset.browseCategory);
      this.toggleAttribute('data-single-group', groupCount === 1); this.updateAvailableHeight();
      if (focus) this.browser.querySelector('[data-category-panel]:not([hidden]) a[href]')?.focus();
      else if (!preserveFocus) button.focus();
    }
    updateAvailableHeight() { if (this.panel.hidden) return; const available = Math.max(0, Math.floor(window.innerHeight - this.panel.getBoundingClientRect().top - 16)); this.style.setProperty('--btl-menu-available-height', available + 'px'); } close(restoreFocus) {
      clearTimeout(this.hoverTimer);
      this.hoverOpened = false;
      if (!this.panel) return;
      const button = this.activeButton;
      this.panel.hidden = true;
      this.activeButton = null;
      this.buttons.forEach(item => item.setAttribute('aria-expanded', 'false'));
      if (restoreFocus) button?.focus();
    }
    onKeydown(event) {
      const button = event.target.closest('[data-browse-department]');
      const index = this.buttons.indexOf(button);
      if (index < 0) return;
      if (event.key === 'ArrowDown') { event.preventDefault(); this.open(button, true); return; }
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % this.buttons.length;
      else if (event.key === 'ArrowLeft') next = (index - 1 + this.buttons.length) % this.buttons.length;
      else if (event.key === 'Home') next = 0;
      else if (event.key === 'End') next = this.buttons.length - 1;
      else return;
      event.preventDefault();
      if (!this.panel.hidden) this.open(this.buttons[next]);
      this.buttons[next].focus();
    }
    disconnectedCallback() { this.controller?.abort(); this.close(false); }
  });
}
